// Module
var code = "<app-header></app-header> <div class=\"documentation-body\"> <app-sidebar></app-sidebar> <main id=\"appMain\" class=\"documentation-content\"></main> </div> ";
// Exports
export default code;